import { useState } from 'react';

interface IzakayaShopsProps {
  lang: 'ja' | 'en';
}

const content = {
  ja: {
    badge: '🍺 おすすめ店舗',
    title: 'エリア別・厳選居酒屋ガイド',
    subtitle: 'ガイドが実際に通う、地元民だけが知る名店',
    areas: [
      {
        area: '荏原町',
        color: 'amber',
        shops: [
          {
            name: '大衆酒場 えびす',
            type: 'せんべろ居酒屋',
            price: '¥500〜¥1,500',
            tags: ['もつ焼き', '昭和レトロ', '常連多数'],
            description: '昭和30年代から続く老舗。炭火で焼くもつ焼きが絶品。地元のおじさんたちと肩を並べて飲む体験は格別。',
            image: 'https://public.readdy.ai/ai/img_res/bf6c20dfd83085860ad5d024132e44e9.jpg',
            highlight: '名物：炭火もつ焼き',
          },
          {
            name: '立ち飲み 三平',
            type: '立ち飲みバー',
            price: '¥300〜¥1,000',
            tags: ['立ち飲み', '激安', 'ホッピー'],
            description: 'ホッピー1杯300円から。立ち飲みスタイルで地元の人と自然と会話が生まれる。外国人にも大人気の穴場スポット。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20standing%20bar%20tachinom%20small%20narrow%20counter%20hoppy%20beer%20cheap%20local%20izakaya%20evening%20warm%20light%20bottles%20lined%20up%20retro%20showa%20neighborhood%20bar&width=600&height=400&seq=shop-sanpei-ebara&orientation=landscape',
            highlight: '名物：ホッピーセット',
          },
        ],
      },
      {
        area: '中延',
        color: 'orange',
        shops: [
          {
            name: '焼き鳥 鳥政',
            type: '焼き鳥専門店',
            price: '¥800〜¥2,000',
            tags: ['焼き鳥', '地鶏', 'せんべろ'],
            description: '地元産の地鶏を使った焼き鳥が自慢。1本80円〜という驚きの価格。煙が漂う店内は昭和の居酒屋そのもの。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20yakitori%20restaurant%20charcoal%20grill%20chicken%20skewers%20smoke%20rising%20warm%20orange%20glow%20small%20local%20izakaya%20counter%20seats%20traditional%20showa%20atmosphere&width=600&height=400&seq=shop-torimasa-nakanobu&orientation=landscape',
            highlight: '名物：地鶏ねぎま串',
          },
          {
            name: 'もつ鍋 中延屋',
            type: 'もつ鍋・居酒屋',
            price: '¥1,500〜¥3,000',
            tags: ['もつ鍋', '博多風', '鍋料理'],
            description: '博多直送のもつを使った本格もつ鍋。冬は特に人気で、外国人ゲストにも「人生最高の鍋」と絶賛される一品。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20motsu%20nabe%20hot%20pot%20restaurant%20steaming%20broth%20offal%20vegetables%20cozy%20izakaya%20interior%20warm%20lighting%20local%20neighborhood%20dining%20authentic%20hakata%20style&width=600&height=400&seq=shop-nakanobuya&orientation=landscape',
            highlight: '名物：博多風もつ鍋',
          },
        ],
      },
      {
        area: '戸越',
        color: 'red',
        shops: [
          {
            name: '戸越銀座 大黒屋',
            type: '大衆居酒屋',
            price: '¥1,000〜¥2,500',
            tags: ['戸越銀座', '刺身', '地酒'],
            description: '戸越銀座商店街の老舗居酒屋。新鮮な刺身と地酒の組み合わせが絶品。商店街の賑わいを感じながら飲める最高のロケーション。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20izakaya%20inside%20Togoshi%20Ginza%20shopping%20street%20fresh%20sashimi%20sake%20local%20pub%20warm%20evening%20atmosphere%20traditional%20wooden%20interior%20bustling%20neighborhood&width=600&height=400&seq=shop-daikokuya-togoshi&orientation=landscape',
            highlight: '名物：本日の刺身盛り',
          },
          {
            name: 'ホルモン 戸越苑',
            type: 'ホルモン焼き',
            price: '¥1,200〜¥2,800',
            tags: ['ホルモン', '炭火焼き', '肉'],
            description: '炭火で焼くホルモンが名物。外国人ゲストが「こんな料理があったのか！」と驚く、日本のB級グルメの真髄。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20horumon%20yakiniku%20charcoal%20grill%20offal%20meat%20restaurant%20local%20izakaya%20smoky%20atmosphere%20counter%20seats%20warm%20glow%20authentic%20neighborhood%20dining&width=600&height=400&seq=shop-togoshien&orientation=landscape',
            highlight: '名物：ミックスホルモン',
          },
        ],
      },
      {
        area: '武蔵小山',
        color: 'yellow',
        shops: [
          {
            name: '武蔵小山 酒場 山田',
            type: '昭和レトロ居酒屋',
            price: '¥1,000〜¥2,500',
            tags: ['昭和レトロ', 'アーケード', '老舗'],
            description: 'アーケード商店街の中にある昭和レトロな居酒屋。壁一面に貼られた手書きメニューと、大将の人情味あふれる接客が魅力。',
            image: 'https://readdy.ai/api/search-image?query=Musashi-Koyama%20covered%20arcade%20shopping%20street%20izakaya%20retro%20showa%20interior%20handwritten%20menu%20wooden%20walls%20warm%20amber%20light%20local%20master%20chef%20counter&width=600&height=400&seq=shop-yamada-musashi&orientation=landscape',
            highlight: '名物：大将のおまかせ',
          },
          {
            name: 'クラフトビール 小山醸造',
            type: 'クラフトビールバー',
            price: '¥800〜¥2,000',
            tags: ['クラフトビール', 'モダン', '地ビール'],
            description: '地元産クラフトビールが10種類以上。昭和レトロな街並みの中に現れるモダンなビールバー。外国人に特に人気のスポット。',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20craft%20beer%20bar%20modern%20interior%20tap%20handles%20multiple%20beers%20local%20brewery%20neighborhood%20bar%20warm%20lighting%20cozy%20atmosphere%20Tokyo%20local%20pub&width=600&height=400&seq=shop-koyamabrewery&orientation=landscape',
            highlight: '名物：季節限定クラフトビール',
          },
        ],
      },
    ],
    note: '※ 掲載店舗はガイドが実際に訪問・厳選した店舗です。ツアー当日は混雑状況や営業状況により、別の名店をご案内する場合があります。',
    cta: 'WhatsAppで詳しく聞く',
  },
  en: {
    badge: '🍺 Recommended Spots',
    title: 'Area-by-Area Izakaya Guide',
    subtitle: 'Hand-picked by your guide — places only locals know',
    areas: [
      {
        area: 'Ebara-cho',
        color: 'amber',
        shops: [
          {
            name: 'Taishū Sakaba Ebisu',
            type: 'Senbero Izakaya',
            price: '¥500–¥1,500',
            tags: ['Motsu-yaki', 'Showa Retro', 'Full of Regulars'],
            description: 'A beloved institution since the 1950s. The charcoal-grilled offal skewers are legendary. Sitting elbow-to-elbow with local salarymen is an experience in itself.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20retro%20izakaya%20interior%20warm%20amber%20light%20wooden%20counter%20old%20showa%20era%20pub%20small%20cozy%20yakitori%20motsu%20grilled%20skewers%20smoky%20atmosphere%20local%20regulars&width=600&height=400&seq=shop-ebisu-ebara-en&orientation=landscape',
            highlight: 'Must-try: Charcoal Motsu-yaki',
          },
          {
            name: 'Tachinom Sanpei',
            type: 'Standing Bar',
            price: '¥300–¥1,000',
            tags: ['Standing Bar', 'Super Cheap', 'Hoppy Beer'],
            description: 'Hoppy beer from ¥300. The standing-bar format naturally sparks conversations with locals. A hidden gem that foreign visitors absolutely love.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20standing%20bar%20tachinomi%20small%20narrow%20counter%20hoppy%20beer%20cheap%20local%20izakaya%20evening%20warm%20light%20bottles%20lined%20up%20retro%20showa%20neighborhood%20bar&width=600&height=400&seq=shop-sanpei-ebara-en&orientation=landscape',
            highlight: 'Must-try: Hoppy Set',
          },
        ],
      },
      {
        area: 'Nakanobu',
        color: 'orange',
        shops: [
          {
            name: 'Yakitori Torimasa',
            type: 'Yakitori Specialist',
            price: '¥800–¥2,000',
            tags: ['Yakitori', 'Free-range Chicken', 'Senbero'],
            description: 'Skewers made from locally sourced free-range chicken, from just ¥80 each. The smoke-filled interior is pure Showa-era izakaya.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20yakitori%20restaurant%20charcoal%20grill%20chicken%20skewers%20smoke%20rising%20warm%20orange%20glow%20small%20local%20izakaya%20counter%20seats%20traditional%20showa%20atmosphere&width=600&height=400&seq=shop-torimasa-nakanobu-en&orientation=landscape',
            highlight: 'Must-try: Negima Skewer',
          },
          {
            name: 'Motsu Nabe Nakanobuya',
            type: 'Motsu Nabe & Izakaya',
            price: '¥1,500–¥3,000',
            tags: ['Motsu Nabe', 'Hakata Style', 'Hot Pot'],
            description: 'Authentic motsu nabe using offal direct from Hakata. Foreign guests regularly call it "the best hot pot of my life."',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20motsu%20nabe%20hot%20pot%20restaurant%20steaming%20broth%20offal%20vegetables%20cozy%20izakaya%20interior%20warm%20lighting%20local%20neighborhood%20dining%20authentic%20hakata%20style&width=600&height=400&seq=shop-nakanobuya-en&orientation=landscape',
            highlight: 'Must-try: Hakata Motsu Nabe',
          },
        ],
      },
      {
        area: 'Togoshi',
        color: 'red',
        shops: [
          {
            name: 'Togoshi Ginza Daikokuya',
            type: 'Classic Izakaya',
            price: '¥1,000–¥2,500',
            tags: ['Togoshi Ginza', 'Sashimi', 'Local Sake'],
            description: 'A long-established izakaya right on Togoshi Ginza shopping street. Fresh sashimi paired with local sake, enjoyed amid the lively street atmosphere.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20izakaya%20inside%20Togoshi%20Ginza%20shopping%20street%20fresh%20sashimi%20sake%20local%20pub%20warm%20evening%20atmosphere%20traditional%20wooden%20interior%20bustling%20neighborhood&width=600&height=400&seq=shop-daikokuya-togoshi-en&orientation=landscape',
            highlight: 'Must-try: Daily Sashimi Platter',
          },
          {
            name: 'Horumon Togoshien',
            type: 'Horumon Grill',
            price: '¥1,200–¥2,800',
            tags: ['Horumon', 'Charcoal Grill', 'Meat'],
            description: 'Charcoal-grilled offal at its finest. Foreign guests are always amazed — this is the true soul of Japanese B-grade gourmet.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20horumon%20yakiniku%20charcoal%20grill%20offal%20meat%20restaurant%20local%20izakaya%20smoky%20atmosphere%20counter%20seats%20warm%20glow%20authentic%20neighborhood%20dining&width=600&height=400&seq=shop-togoshien-en&orientation=landscape',
            highlight: 'Must-try: Mixed Horumon',
          },
        ],
      },
      {
        area: 'Musashi-Koyama',
        color: 'yellow',
        shops: [
          {
            name: 'Sakaba Yamada',
            type: 'Showa Retro Izakaya',
            price: '¥1,000–¥2,500',
            tags: ['Showa Retro', 'Arcade', 'Long-established'],
            description: 'A Showa-era gem tucked inside the covered arcade. Handwritten menus cover every wall, and the master\'s warm hospitality makes every guest feel at home.',
            image: 'https://readdy.ai/api/search-image?query=Musashi-Koyama%20covered%20arcade%20shopping%20street%20izakaya%20retro%20showa%20interior%20handwritten%20menu%20wooden%20walls%20warm%20amber%20light%20local%20master%20chef%20counter&width=600&height=400&seq=shop-yamada-musashi-en&orientation=landscape',
            highlight: 'Must-try: Chef\'s Omakase',
          },
          {
            name: 'Craft Beer Koyama Brewery',
            type: 'Craft Beer Bar',
            price: '¥800–¥2,000',
            tags: ['Craft Beer', 'Modern', 'Local Brew'],
            description: 'Over 10 local craft beers on tap. A modern beer bar that surprises visitors amid the retro streetscape. Especially popular with foreign guests.',
            image: 'https://readdy.ai/api/search-image?query=Japanese%20craft%20beer%20bar%20modern%20interior%20tap%20handles%20multiple%20beers%20local%20brewery%20neighborhood%20bar%20warm%20lighting%20cozy%20atmosphere%20Tokyo%20local%20pub&width=600&height=400&seq=shop-koyamabrewery-en&orientation=landscape',
            highlight: 'Must-try: Seasonal Craft Beer',
          },
        ],
      },
    ],
    note: '※ All spots are personally visited and curated by your guide. On the day of the tour, we may visit other great spots depending on availability and crowd levels.',
    cta: 'Ask Us on WhatsApp',
  },
};

const colorMap: Record<string, { bg: string; badge: string; border: string; tag: string; highlight: string }> = {
  amber: {
    bg: 'bg-amber-50',
    badge: 'bg-amber-600',
    border: 'border-amber-200',
    tag: 'bg-amber-100 text-amber-700 border-amber-200',
    highlight: 'bg-amber-100 text-amber-800',
  },
  orange: {
    bg: 'bg-orange-50',
    badge: 'bg-orange-600',
    border: 'border-orange-200',
    tag: 'bg-orange-100 text-orange-700 border-orange-200',
    highlight: 'bg-orange-100 text-orange-800',
  },
  red: {
    bg: 'bg-red-50',
    badge: 'bg-red-600',
    border: 'border-red-200',
    tag: 'bg-red-100 text-red-700 border-red-200',
    highlight: 'bg-red-100 text-red-800',
  },
  yellow: {
    bg: 'bg-yellow-50',
    badge: 'bg-yellow-600',
    border: 'border-yellow-200',
    tag: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    highlight: 'bg-yellow-100 text-yellow-800',
  },
};

export const IzakayaShops: React.FC<IzakayaShopsProps> = ({ lang }) => {
  const t = content[lang];
  const [activeArea, setActiveArea] = useState(0);

  const handleWhatsAppClick = () => {
    const message =
      lang === 'ja'
        ? 'おすすめ居酒屋ツアーについて詳しく教えてください'
        : 'Hi! I just checked out your recommended izakaya spots (Ebisu, Torimasa, Daikokuya, etc.) and I\'m very interested! Could you tell me more about the tour and how to book?';
    window.open(`https://wa.me/819092895522?text=${encodeURIComponent(message)}`, '_blank');
  };

  const activeData = t.areas[activeArea];
  const colors = colorMap[activeData.color];

  return (
    <section className="py-20 px-6 bg-stone-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            {t.badge}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-lg text-gray-500">{t.subtitle}</p>
        </div>

        {/* Area Tab Selector */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {t.areas.map((area, idx) => {
            const c = colorMap[area.color];
            const isActive = activeArea === idx;
            return (
              <button
                key={idx}
                onClick={() => setActiveArea(idx)}
                className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                  isActive
                    ? `${c.badge} text-white shadow-md scale-105 border-transparent`
                    : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:text-amber-700'
                }`}
              >
                {area.area}
              </button>
            );
          })}
        </div>

        {/* Shop Cards */}
        <div className={`rounded-3xl p-8 border ${colors.bg} ${colors.border} mb-8`}>
          <div className="flex items-center gap-3 mb-8">
            <span className={`text-white text-sm font-bold px-4 py-1.5 rounded-full ${colors.badge}`}>
              {activeData.area}
            </span>
            <span className="text-gray-500 text-sm">{activeData.shops.length}{lang === 'ja' ? '店舗掲載' : ' spots'}</span>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {activeData.shops.map((shop, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                {/* Shop Image */}
                <div className="w-full h-48 overflow-hidden relative">
                  <img
                    src={shop.image}
                    alt={shop.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`text-xs font-bold px-3 py-1 rounded-full ${colors.highlight}`}>
                      {shop.highlight}
                    </span>
                  </div>
                </div>

                {/* Shop Info */}
                <div className="p-5">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900">{shop.name}</h3>
                      <p className="text-sm text-gray-500">{shop.type}</p>
                    </div>
                    <span className="text-sm font-semibold text-gray-700 bg-gray-100 px-3 py-1 rounded-full whitespace-nowrap ml-2">
                      {shop.price}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-1.5 mb-3">
                    {shop.tags.map((tag, ti) => (
                      <span
                        key={ti}
                        className={`text-xs font-medium px-2.5 py-0.5 rounded-full border ${colors.tag}`}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <p className="text-sm text-gray-600 leading-relaxed">{shop.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Note */}
        <p className="text-center text-xs text-gray-400 mb-8">{t.note}</p>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 hover:bg-green-600 text-white text-lg font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            {t.cta}
          </button>
        </div>
      </div>
    </section>
  );
};
